cv.TeamActivityView = Marionette.LayoutView.extend({
  className : 'page-team',

  getTemplate: function(){
    return cv.Templates['team/activity'];
  },

  bindings : {
    ':el' : {
      observe : 'photo_path',
      update: function($el, value, model, options) {
        var $replace = $el.find('#team-progress .profile-photo').clone();

        $replace.attr('data-src', cv.photo({
          photo_path : model.get('photo_path'),
          photo_default : cv.campaign.get('default_team_photo'),
          url_only : true,
          transforms : {
            fit : 'crop'
          }
        }));

        $el.find('#team-progress .profile-photo').replaceWith($replace);

        imgix.fluid($el.get(0), {
          updateOnResizeDown: false,
          pixelStep: 5,
          autoInsertCSSBestPractices: true
        });
      }
    }
  },
  
  regions: {
    tab_content : '#tab-widget-content'
  },

  events: {
    'click .tabs-widget a' : 'changeTab'
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    console.log('DashboardActivityView initialized');
  },

  templateHelpers: function () {
    return {
    };
  },

  changeTab: function(e){
    if(_.isObject(e)){
      e.preventDefault();
      var tab = $(e.currentTarget).attr('id').split('-')[1];
    }else{
      var tab = e;
    }

    this.$('.tabs a').removeClass('active');
    this.$('#tab-' + tab).addClass('active');

    switch(tab){
      case 'members':
        var view = new cv.FeedView({
          collection : new cv.Activities(null, {
            params : {
              project_id : cv.project.get('id')
            }
          })
        });
        break;
    }
    this.showChildView('tab_content', view);
  },

  renderMyProgress: function(){
    var percent_progress = Math.round(cv.project.get('funds_raised')/cv.project.get('funds_needed') * 100);
    if(percent_progress > 100){
      percent_progress = 100;
    }

    this.$('#my-progress').append(cv.Templates['team/progress']({
      is_team : true,
      title : 'My Progress',
      url : cv.project.get('url'),
      stub : cv.project.get('stub'),
      percent_progress : percent_progress,
      funds_raised : cv.formatMoney({
        show_sign : true,
        amount : cv.project.get('funds_raised'),
        currency_code : cv.campaign.get('currency_code'),
        decimal_places : 2
      }),
      funds_needed : cv.formatMoney({
        show_sign : true,
        amount : cv.project.get('funds_needed'),
        currency_code : cv.campaign.get('currency_code'),
        decimal_places : 2
      }),
      num_donations : cv.project.get('num_donations')
    }));

    // Bind profile photo stuff
    this.stickit(cv.user);
  },

  onAttach: function(){
    // Set initial tab
    this.changeTab('members');

    // Render regular progress
    this.renderMyProgress();

    // Change document title
    document.title = cv.campaign.get('title') + ' | ' + this.model.get('name');
  }
});
